/**
 * WhatsAppEnvioDialog - Modal para gerar link de WhatsApp por fornecedor de uma cotação
 * (extraído de Compras.jsx).
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { MessageCircle } from 'lucide-react';

const WhatsAppEnvioDialog = ({ cotacao, onClose, onGerarLink }) => {
  return (
    <Dialog open={!!cotacao} onOpenChange={() => onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageCircle className="w-5 h-5 text-green-600" />
            Enviar via WhatsApp
          </DialogTitle>
        </DialogHeader>

        {cotacao && (
          <div className="space-y-4">
            <p className="text-sm text-gray-600">
              Selecione o fornecedor para enviar a cotação via WhatsApp:
            </p>
            <div className="space-y-2">
              {cotacao.fornecedores?.map(forn => (
                <Button
                  key={forn.fornecedor_id}
                  variant="outline"
                  className="w-full justify-between"
                  onClick={() => onGerarLink(cotacao.id, forn.fornecedor_id, forn.fornecedor_nome)}
                >
                  <span>{forn.fornecedor_nome}</span>
                  <span className="text-gray-500 text-sm">{forn.contato_telefone}</span>
                </Button>
              ))}
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onClose()}>
            Cancelar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsAppEnvioDialog;
